import { differenceInCalendarDays, format, subDays } from 'date-fns';

/**
 * Computes the comparison period by shifting the selected range back by its own duration.
 * E.g. "Last 7 days" (days 1–7) → comparison is days 8–14.
 *
 * @param startDate - "yyyy-MM-dd" string
 * @param endDate   - "yyyy-MM-dd" string
 * @returns comparison period in the same "yyyy-MM-dd" format
 */
export const getComparisonDates = (
  startDate: string,
  endDate: string
): { startDate: string; endDate: string } => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dayCount = differenceInCalendarDays(end, start) + 1;

  const comparisonEnd = subDays(start, 1);
  const comparisonStart = subDays(start, dayCount);

  return {
    startDate: format(comparisonStart, 'yyyy-MM-dd'),
    endDate: format(comparisonEnd, 'yyyy-MM-dd'),
  };
};
